<template>
  <div class="c-footer">
    <nav class="c-footer__nav" :class="{ editMode: isEditing }" aria-label="Footer Navigation">
      <div>
        <sc-placeholder name="jss-footer-navlist-column" :rendering="rendering" />
      </div>
    </nav>
    <div class="c-footer__global" :class="{ editMode: isEditing }">
      <div class="c-footer__links">
        <sc-placeholder name="jss-footer-utility-links" :rendering="rendering" />
      </div>
      <div class="c-footer__social">
        <sc-placeholder name="jss-footer-social-links" :rendering="rendering" />
      </div>
    </div>
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Footer',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    rendering: {
      type: Object
    }
  },
  data: function () {
    return {
      isActive: false
    };
  },
  computed: {
    isEditing() {
      return this.$jss.sitecoreContext().pageEditing;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-footer {
  max-width: none;
  margin: 0 auto;
  @include padding-y(3rem);

  &__nav {
    display: flex;
    flex-wrap: wrap;
    flex-basis: 100%;
    @include padding-x-thin;

    > div {
      display: flex;
      flex-wrap: wrap;
      flex-basis: 100%;
    }
  }

  &__global {
    display: flex;
    flex-basis: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 2.5rem;
    @include padding-x-thin;

    &.editMode {
      display: block;

      .c-footer__links {
        float: left;
      }

      .c-footer__social {
        float: right;
        min-width: 10rem;
        text-align: right;
      }
    }
  }
}
</style>
